import type { Palette } from "./types";

const GRAPHITE = {
	0: "#000000",
	10: "#141416",
	20: "#28282A",
	30: "#3D3D40",
	40: "#525256",
	50: "#67676C",
	60: "#7C7C83",
	70: "#919197",
	80: "#A8A7AB",
	90: "#BCBCC0",
	95: "#D3D3D5",
	99: "#E9E9EA",
	100: "#FFFFFF",
} as const;

const TONES = {
	primary: GRAPHITE,
	secondary: GRAPHITE,
	tertiary: GRAPHITE,
	error: GRAPHITE,
	graphite: GRAPHITE,
	background: GRAPHITE,
} as const;

const MAIN_COLORS = {
	primary: GRAPHITE[60],
	secondary: GRAPHITE[60],
	tertiary: GRAPHITE[60],
	error: GRAPHITE[60],
} as const;

const ACCENT_COLORS = {
	primary: GRAPHITE[99],
	graphite: GRAPHITE[60],
} as const;

const NEUTRAL_COLORS = {
	graphite: GRAPHITE[20],
	background: GRAPHITE[95],
	white: GRAPHITE[100],
	black: GRAPHITE[0],
} as const;

const PALETTE = {
	main: MAIN_COLORS,
	accent: ACCENT_COLORS,
	neutral: NEUTRAL_COLORS,
	tones: TONES,
} as const satisfies Palette;

export { PALETTE };
